import getWindow from './getWindow';
import { isFullscreenEditorLayout } from './isFullscreenEditor';
import isVerticalNavExclusionRoute from './isVerticalNavExclusionRoute';
const getIsVerticalNavEnabledForTheCurrentPath = ({
  verticalNavExclusionRoutes,
  pathname = getWindow().location.pathname
}) => {
  if (isFullscreenEditorLayout() || isVerticalNavExclusionRoute(pathname, verticalNavExclusionRoutes)) {
    return false;
  }
  return true;
};
export default getIsVerticalNavEnabledForTheCurrentPath;